// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'draf... Remove this comment to see the full error message
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'draf... Remove this comment to see the full error message
import DomainPattern from 'PatternValidationJS/patterns/Domain';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'draf... Remove this comment to see the full error message
import UrlPattern from 'PatternValidationJS/patterns/Url';
import { propertyKeyValidationTypes } from '../constants/properties';
import { phone_regex_country_code, phone_regex_no_country_code } from '../constants/regExp';
export const createCrmObjectFormValidator = formFields => formFields.map(field => {
  switch (field.name) {
    case propertyKeyValidationTypes.email:
      field.valid = field.value ? EmailAddressPattern.test(field.value) : true;
      break;
    case propertyKeyValidationTypes.domain:
      field.valid = field.value ? DomainPattern.test(field.value) : true;
      break;
    case propertyKeyValidationTypes.linkedin_company_page:
      field.valid = field.value ? UrlPattern.test(field.value) : true;
      break;
    case propertyKeyValidationTypes.phone:
      field.valid = field.value ? phone_regex_country_code.test(field.value) || phone_regex_no_country_code.test(field.value) : true;
      break;
    default:
      field.valid = field.externalOptions || !field.required || field.required && !!field.value;
      break;
  }
  return field;
});